import Phaser from 'phaser';

export class PreloadingScene extends Phaser.Scene {
  constructor() {
    super('PreloadingScene');
  }


  preload() {
    this.preloadImages();
    this.preloadAudio();


  }


  preloadImages() {

    let pulse = "assets/";
    let config = null;
    // @ts-ignore
    if (typeof PblInterface !== 'undefined') {
      // @ts-ignore
      config = PblInterface.game.config;
    } else {
      config = window._po_gm.config;
    }
    // @ts-ignore
    switch (config?.pulse) {
      case '1':
        pulse += 'pulse1/';
        break;
      case '2':
        pulse += 'pulse2/';
        break;
      default:
        pulse += 'pulse1/';
        break;
    }
    //this.load.image('call-tile-covered', 'assets/pulse2/tiles/call-tile-covered.png');
    console.log('assets/pulse2/tiles/call-tile-covered.png');
    console.log(pulse + 'tiles/call-tile-covered.png');
    this.load.image('grid-background',  pulse + '/tiles/grid-background.png');
    this.load.image('grid-blank',  pulse + 'tiles/grid-blank.png');
    this.load.image('grid-covered',   pulse + 'tiles/grid-covered.png');
    this.load.image('grid-matched',   pulse + 'tiles/grid-matched.png');
    this.load.image('grid-revealed',  pulse + 'tiles/grid-revealed.png');
    this.load.image('call-tile-title',  pulse + 'tiles/call-tile-title.png');
    this.load.image('call-tile-covered',  pulse + 'tiles/call-tile-covered.png');
    this.load.image('call-tile-revealed',  pulse + 'tiles/call-tile-revealed.png');
    this.load.image('call-tile-revealed-effect',  pulse + 'tiles/effects/call-tile-revealed-effect.png');
    this.load.image('BottomBarBackground',  pulse + 'BottomBarBackground.png');

    this.load.image('ok-btn',  pulse + 'buttons/ok_btn.png');
    this.load.image('yes-btn',  pulse + 'buttons/yes_btn.png');
    this.load.image('no-btn',  pulse + 'buttons/no_btn.png');
    this.load.image('hint-btn',  pulse + 'buttons/hint.png');
    this.load.image('reveal-btn',  pulse + 'buttons/autoplay.png');
    this.load.image('prizes-btn',  pulse + 'buttons/prizes.png');
    this.load.image('exit-btn',  pulse + 'buttons/exit-btn.png');
    this.load.image('next-btn',  pulse + 'buttons/next-btn.png');
    this.load.image('playagain-btn',  pulse + 'buttons/playagain_btn.png');
    this.load.image('playfortoken-btn',  pulse + 'buttons/playfortoken_btn.png');
    this.load.image('menu-btn',  pulse + 'buttons/settings.png');
    this.load.image('menuclose-btn',  pulse + 'buttons/menu-close.png');
    this.load.image('exitgame-btn',  pulse + 'buttons/exit-game.png');
    this.load.image('howtoplayclose-btn',  pulse + 'buttons/how-to-play-close.png');

    this.load.image('skip-btn',  pulse + 'buttons/skip.png');
    this.load.image('info-btn',  pulse + 'buttons/info.png');
    this.load.image('title-window', pulse + 'main_menu_background.png');
    this.load.image('play-fun-btn', pulse + 'buttons/play-fun-btn.png');
    this.load.image('play-prizes-btn', pulse + 'buttons/play-prizes-btn.png');
    this.load.image('enter-codes-btn', pulse + 'buttons/enter-codes-btn.png');


    this.load.image('branding',  pulse + 'Branding.png');
    this.load.image('letter-to-find',  pulse + 'letter-to-find.png');
    this.load.image('scorebox',  pulse + 'scorebox.png');
    this.load.image('word-matched-token',  pulse + 'star.png');
    this.load.image('menu-background',  pulse + 'background/menu-background.png');
    this.load.image('content-background',  pulse + 'background/content-background.png');

    this.load.image('5-prize',  pulse + '5-prize.png');
    this.load.image('10-prize',  pulse + '10-prize.png');
    this.load.image('20-prize',  pulse + '20-prize.png');
    this.load.image('40-prize',  pulse + '40-prize.png');
    this.load.image('50-prize',  pulse + '50-prize.png');
    this.load.image('100-prize',  pulse + '100-prize.png');
    this.load.image('1000-prize',  pulse + '1000-prize.png');
    this.load.image('2500-prize',  pulse + '2500-prize.png');
    this.load.image('50000-prize',  pulse + '50000-prize.png');



    this.load.image('hint-1',  pulse + 'hints/hint_1.png');
    this.load.image('hint-2',  pulse + 'hints/hint_2.png');
    this.load.image('hint-3',  pulse + 'hints/hint_3.png');
    this.load.image('hint-4',  pulse + 'hints/hint_4.png');
    this.load.image('title-htp-btn',  pulse + 'buttons/how to play.png');
    this.load.image('title-playnow-btn',  pulse + 'buttons/playnow.png');
    this.load.image('menu-htp-btn',  pulse + 'buttons/menu-howtoplay.png');
    this.load.image('menu-volume-btn',  pulse + 'buttons/main-volume.png');
    this.load.image('menu-prize-table-btn',  pulse + 'buttons/menu-prizetable.png');
    this.load.image('menu-mute-btn',  pulse + 'buttons/music-off-btn.png');
    this.load.image('menu-max-btn',  pulse + 'buttons/music-on-btn.png');
    this.load.image('menu-sound-node',  pulse + 'buttons/volume_slider.png');
    this.load.image('menu-sound-track',  pulse + 'buttons/volume_track.png');
    this.load.image('resultsbackground',  pulse + 'resultsbackground.png');
    this.load.image('congrats',  pulse + 'congrats-text.png');

    this.load.image('visit',  pulse + 'visit.png');
    this.load.image('fun-message',  pulse + 'thanks-for-playing.png');

    this.load.image('flare',  pulse + 'Flare.png');

    this.load.image('sorry',  pulse + 'sorry.png');
    this.load.image('not-a-winner',  pulse + 'not-a-winner.png');
    this.load.image('play-for-fun',  pulse + 'thanks-for-playing.png');
    this.load.image('prize-table',  pulse + 'prize_table.png');

    //label
    this.load.image('call-letters',  pulse + 'labels/call-letters.png');
    this.load.image('words-matched',  pulse + 'words-matched.png');
    this.load.image('fun-mode',  pulse + 'labels/fun-mode.png');
    const letters = [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z'
    ];

    for (const letter of letters) {
      this.load.image('letter-' + letter.toUpperCase(), 'assets/default/letters/grid/letter-' + letter + '.png');
      this.load.image('letter-instant-' + letter.toUpperCase(), 'assets/default/letters/instant-win/letter-instant-' + letter + '.png');
    }
  }


  preloadAudio() {
    this.load.audio('game-setup', 'assets/default/audio/0024_level_completed_01.mp3');
    this.load.audio('call-tile-revealed', 'assets/default/audio/0024_progress_made_08.mp3');
    this.load.audio('grid-tile-revealed', 'assets/default/audio/0024_ui_03.mp3');
    this.load.audio('grid-tile-word-matched', 'assets/default/audio/0009_magic_element_light_a.mp3');
    this.load.audio('grid-tile-reveal-blocked', 'assets/default/audio/0024_wrong_answer_10.mp3');
    this.load.audio('hint', 'assets/default/audio/0024_item_collected_03.mp3');
    this.load.audio('button-press', 'assets/default/audio/0024_ui_selection_02.mp3');
    this.load.audio('end-of-game', 'assets/default/audio/0024_progress_made_14.mp3');
    this.load.audio('instant-word-win', 'assets/default/audio/instantword_win.mp3');
    this.load.audio('bg-music-custom', 'assets/default/audio/background.mp3');

  }

  create() {

    this.scene.start('CrosswordScene');

  }
}
